import Vue from 'vue';
import DoorbraakApp from './DoorbraakApp.vue';
import router from './router';
import store from './store';
import Vuelidate from 'vuelidate'
import { formatDate } from './core/filters';
import { contactInfo, contactName, memberItem } from './components/filters';
import MemberRemoveModal from '@/components/members/MemberRemovalModal.vue';

Vue.config.productionTip = false;
Vue.use(Vuelidate)

Vue.filter('formatDate', formatDate);

// specific
Vue.filter('contactName', contactName);
Vue.filter('contactInfo', contactInfo);
Vue.filter('memberItem', memberItem);

Vue.component('member-removal-modal', MemberRemoveModal);

new Vue({
  router,
  store,
  render: (h) => h(DoorbraakApp),
}).$mount('#app');
